import { Component, OnInit } from '@angular/core';
import { ClientNotification } from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs';
import { ClientNotificationService } from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-client-nfs-column',
    templateUrl: './client-nfs-column.component.html',
    styleUrls: ['./client-nfs-column.component.scss']
})
export class ClientNfsColumnComponent implements OnInit {
    clientNfs: ClientNotification[];
    totalRecords: number;

    loadingg: boolean;

    isMobile = false;

    constructor(
        protected clientNotificationService: ClientNotificationService,
        protected deviceDetectorService: DeviceDetectorService
    ) { }

    ngOnInit(): void {
        this.loadingg = true;
        this.getNfs();

        this.isMobile = this.deviceDetectorService.isMobile();
    }

    getNfs() {
        this.clientNotificationService.getClientNfs(0, 20).subscribe(clientNfs => {
            // this.clientNfs = [];
            this.clientNfs = clientNfs.content;
            this.loadingg = false;
        })
    }

    dismissMsg(msgId: number) {
        const msgIndex = this.clientNfs.findIndex(msg => msg.id === msgId);

        if (msgIndex > -1) {
            this.clientNfs.splice(msgIndex, 1);
        }

    }

    deleteMsg(msgId: number) {
        const msgIndex = this.clientNfs.findIndex(msg => msg.id === msgId);

        if (msgIndex > -1) {
            this.clientNfs.splice(msgIndex, 1);
        }
    }

    createNewMessage() {

    }

}
